import { Container, Typography } from "@mui/material";
import { agreementDoc } from "../../../utils/constants";

export function ContentRendererTitle(block: any) {
  const { isForAgreementGeneration } = block ?? {};

  return (
    <Container maxWidth="lg" sx={{ mt: isForAgreementGeneration ? undefined : 4, mb: 4 }}>
      <Typography
        variant={block.variant || "h2"}
        align={block.align || "center"}
        sx={{
          ...(isForAgreementGeneration && {
            fontFamily: agreementDoc.fontFamily,
          }),
        }}
      >
        {block.text}
      </Typography>
    </Container>
  );
}
